import { Markdown, Text } from "@wojo/ui";
import { Webform } from "@wojo/webforms";
import React, { useId } from "react";
import { useTourPageContext } from "../../../_client/context";
import { ContactForm } from "./ContactForm";
import { ContactInformation } from "./ContactInformation";
import { useTripBuilder } from "../context/TripBuilderContext";
import { formatDepartureStartAndEndDates } from "../hooks/format-departure-start-and-end-dates";
import { SectionDepartureDates } from "./SectionDepartureDates";

export type ContactProps = {
    formHeading: string;
    formName: Webform;
    callHeading: string;
    formDescription: string;
    callDescription: string;
};

export const Contact: React.FC<ContactProps> = ({
    formHeading,
    formName,
    callHeading,
    formDescription,
    callDescription,
}) => {
    const { pageConfig } = useTourPageContext();
    const { departure, gcDeparture } = useTripBuilder();
    const headerId = useId();
    const hasForm = pageConfig.displayTripBuilderContactForm && !gcDeparture;
    const description = hasForm ? formDescription : callDescription;
    const heading = hasForm ? formHeading : callHeading;

    return (
        <>
            <SectionDepartureDates />
            <div style={{ padding: "var(--g-spacing-lg)" }}>
                <Text.Heading
                    id={headerId}
                    order="5"
                    tag="h2"
                    data-testid="contact-landing-heading"
                    style={{ marginBottom: "var(--g-spacing-md)" }}
                >
                    {heading}
                </Text.Heading>
                <Text.Body>{departure?.tourContent?.name}</Text.Body>
                <Text.Body style={{ marginBottom: "var(--g-spacing-md)" }}>
                    {formatDepartureStartAndEndDates(
                        departure?.departureDate,
                        departure?.endDate,
                    )}
                </Text.Body>
                <Markdown markdown={description} />
                {hasForm ? (
                    <ContactForm formLabel={heading} formName={formName} />
                ) : (
                    <ContactInformation />
                )}
            </div>
        </>
    );
};
